import {Box, Image} from '@mantine/core';
import {type PropsWithChildren, useEffect} from 'react';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import {BANNER_EVENT_IMAGE} from '../../../config/constants/img';
import isAppWebView from '../../../config/isAppWebView';
import {useGoogleAdBanner} from '../../services/useGoogleAdBanner';
import {useMediaQuery} from '../../services/useMediaQuery';
import {GoogleAdBanner} from '../Banner/GoogleAdBanner';
import {GeneralFooter} from '../Footer/general';
import {GeneralHeaderContainer} from '../Header/General/container';
import {ScriptForGA} from '../ScriptForGA';
import {Sidebar} from '../Sidebar';

export const StandardLayout = ({children}: PropsWithChildren) => {
  const {isPC} = useMediaQuery();
  const googleAdBannerNames = [
    GoogleAdBannerName.B_RECTANGLE,
    GoogleAdBannerName.B_RECTANGLE_BOTTOM,
  ];
  const {setShouldRefetch} = useGoogleAdBanner(googleAdBannerNames);

  useEffect(() => {
    setShouldRefetch(true);
  }, []);

  return (
    <>
      <div>
        {!isAppWebView() && <GeneralHeaderContainer />}
        <main>
          <Box className="min-h-screen py-12 pc:bg-background-1 pc:py-32">
            <Box className="mx-auto my-0 max-w-[1200px] overflow-hidden">
              <Box className="flex items-start gap-x-16">
                {isPC && <Sidebar className="max-w-[200px]" />}
                <Box className="w-full max-w-[664px]">{children}</Box>
                {isPC && (
                  <Box className="w-[320px]">
                    <Box className="sticky top-[150px] flex flex-col gap-y-8">
                      <GoogleAdBanner
                        googleAdBannerName={GoogleAdBannerName.B_RECTANGLE}
                      />
                      <a
                        href="https://event.gaishishukatsu.com/"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <Image
                          src={BANNER_EVENT_IMAGE}
                          alt="開催イベント一覧"
                          width={300}
                          height={80}
                        />
                      </a>
                      <GoogleAdBanner
                        googleAdBannerName={
                          GoogleAdBannerName.B_RECTANGLE_BOTTOM
                        }
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </main>
        {!isAppWebView() && <GeneralFooter />}
      </div>
      <ScriptForGA />
    </>
  );
};
